// `sort` starts at 1 — the customer frontend's "who" filter only matches
// junction rows where `sort = 1` (the primary target audience). Without this,
// filtering by target audience returns zero events.
export const mapTagsToTargetAudiences = (tags?: string[]) =>
  tags?.map((tag, index) => ({
    target_audiences_id: { id: Number.parseInt(tag, 10) },
    sort: index + 1,
  }));
